module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/treadmill-289a5dc32357506609cc80d0ddf70bdc.svg";